'use client';

import { c as _c } from "react/compiler-runtime";
import * as SeparatorPrimitive from '@radix-ui/react-separator';
import * as React from 'react';
import { cn } from '@/lib/styles';
const Separator = React.forwardRef<React.ElementRef<typeof SeparatorPrimitive.Root>, React.ComponentPropsWithoutRef<typeof SeparatorPrimitive.Root>>((t0, ref) => {
  const $ = _c(14);
  let className;
  let props;
  let t1;
  let t2;
  if ($[0] !== t0) {
    ({
      className,
      orientation: t1,
      decorative: t2,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
    $[3] = t1;
    $[4] = t2;
  } else {
    className = $[1];
    props = $[2];
    t1 = $[3];
    t2 = $[4];
  }
  const orientation = t1 === undefined ? "horizontal" : t1;
  const decorative = t2 === undefined ? true : t2;
  const t3 = orientation === "horizontal" ? "h-px w-full" : "h-full w-px";
  let t4;
  if ($[5] !== className || $[6] !== t3) {
    t4 = cn("shrink-0 bg-border", t3, className);
    $[5] = className;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== decorative || $[9] !== orientation || $[10] !== props || $[11] !== ref || $[12] !== t4) {
    t5 = <SeparatorPrimitive.Root ref={ref} decorative={decorative} orientation={orientation} className={t4} {...props} />;
    $[8] = decorative;
    $[9] = orientation;
    $[10] = props;
    $[11] = ref;
    $[12] = t4;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  return t5;
});
Separator.displayName = SeparatorPrimitive.Root.displayName;
export { Separator };